/*=========================================================================================
  File Name: moduleHospital.js
  Description: Hospital Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleHospitalState.js'
import mutations from './moduleHospitalMutations.js'
import actions from './moduleHospitalActions.js'
import getters from './moduleHospitalGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
